import React from 'react';
import { Button, CircularProgress } from "@mui/material";

const ButtonOutlined = ({
    variant,
    text,
    height,
    width,
    marginRight,
    borderRadius,
    marginLeft,
    marginTop,
    startIcon,
    onClick,
    loading,
    color,
    disableLoader,
    disableElevation,
    href,
    endIcon,
    fontSize,
    disabled,
    fontWeight,
    padding,
    border,
    backgroundColor,
    sx
}) => {
    return (
        <Button
            variant={variant || "outlined"}
            sx={{
                color: color,
                backgroundColor: backgroundColor || "transparent",
                borderRadius: borderRadius || "10px",
                marginTop: marginTop,
                height: height || "35px",
                width: width,
                marginRight: marginRight,
                marginLeft: marginLeft,
                fontSize: fontSize || "12px",
                fontWeight: fontWeight || 400,
                padding: padding,
                border: border || "1px solid #FFFFFF",
                '&:hover': {
                    border: border || "1px solid #FFFFFF",
                },
                '&:focus': {
                    border: border || "1px solid #FFFFFF",
                },
                '&:active': {
                    border: border || "1px solid #FFFFFF",
                },
                '&.Mui-disabled': {
                    border: border || "1px solid #FFFFFF",
                },
                ...sx
            }}
            disableElevation={disableElevation}
            startIcon={startIcon}
            onClick={onClick}
            href={href}
            endIcon={endIcon}
            disabled={disabled}
        >
            {text}
            {
                loading && !disableLoader ? (
                    <CircularProgress
                        size={20}
                        color={"inherit"}
                        sx={{ marginLeft: 3 }}
                    />
                ) : (
                    ""
                )
            }
        </Button >
    );
};

export default ButtonOutlined;
